export enum Genre {
  Animation = '16',
  Documentary = '99',
}
